<template>
  <div id="accountsetting" class="account-setting">
    <p class="setting-name">{{$t('translateText.accountSet.AccountSettings')}}</p>
    <div class="line-top"></div>
    <div class="container">
      <div class="head-portrait" id="container">
        <!-- <Upload></Upload> -->
        <!-- <img
                    class="header-imagin"
                    src="../../assets/imgs/background.png"
                /> -->
        <image-cropper
          class="header-imagin"
          :options="cropperOptions"
          :imgSize="2"
          :imgType="imgType"
          :imageUrl="imgUrl"
          @crop-upload-close="cropClose"
          @crop-upload-success="cropSuccess"
        />
        <div class="complite-header" @click="changeCover">
          <img class="header-img" src="../../assets/imgs/jiahao.png" />

          <p class="header-name">{{$t('translateText.accountSet.EditAvatar')}}</p>
        </div>
      </div>
      <edit-modal
        ref="son"
        :svisible="visible"
        :imgUrl="imgUrl"
        @cancel="editCancel"
        @cropperOk="cropOk"
      ></edit-modal>
      <div class="personal-inform">
        <p class="student student-number">{{$t('translateText.accountSet.UserName')}}:</p>
        <p class="input input-stunumber">{{ userinfo.strUserName }}</p>
        <p class="student name">{{$t('translateText.accountSet.Name')}}:</p>
        <!-- <p class="input input-stuname"></p> -->
        <!-- <p
                    class="input input-stuname"
                    placeholder=""
                >{{userinfo.strRealName}}</p> -->
        <input class="input input-stuname" type="text" v-model="strRealName" />
        <!-- <p
                    class="updatainform updatename"
                    @click="
                        (showName = true),
                            (inputname = false),
                            (inputnames = true)
                    "
                    v-if="edit"
                >
                    更改姓名
                </p> -->
        <p class="student student-sex">{{$t('translateText.accountSet.Gender')}}:</p>
        <a-radio-group
          :default-value="userinfo.ddUserSex.iNumber"
          class="input select-sex"
        >
          <a-radio :value="1" @click="sendrole(1)">{{$t('translateText.accountSet.Male')}}</a-radio>
          <a-radio :value="2" @click="sendrole(2)">{{$t('translateText.accountSet.Female')}}</a-radio>
        </a-radio-group>

        <p class="student student-phone">{{$t('translateText.accountSet.MobileNumber')}}:</p>
        <!-- <p class="input input-phone">{{ userinfo.strUserPhone }}</p> -->
        <input
          class="input input-phone"
          type="text"
          v-model="userinfo.strUserPhone"
        />
        <!-- <p
                    class="updatainform updatephone"
                    @click="
                        (showPhone = true),
                            (inputphone = false),
                            (inputphones = true)
                    "
                    v-if="edit"
                >
                    更改手机号
                </p> -->
        <p class="student student-email">{{$t('translateText.accountSet.Email')}}:</p>
        <!-- <p class="input input-email">{{ userinfo.strUserEmail }}</p> -->
        <input
          class="input input-email"
          type="text"
          v-model="userinfo.strUserEmail"
        />
        <!-- <p
                    class="updatainform updateemail"
                    @click="
                        (showEmail = true),
                            (inputemail = false),
                            (inputemails = true)
                    "
                    v-if="edit"
                >
                    更改邮箱地址
                </p> -->
        
      </div>
      <div class="button">
        <one-button class="inform-button compile" @click="cancel"
          >{{$t('translateText.accountSet.Cancel')}}</one-button>
        <one-button class="inform-button renturn-inform" @click="update"
          >{{$t('translateText.accountSet.Complete')}}</one-button>

      </div>
    </div>
    
    <up-modal />
  </div>
</template>

<script>
import upModal from "@/components/upModal";
import ImageCropper from "@/components/ImageCropper";
import editModal from "@/components/ImageCropper/editModal";
import { UpdateUser, accountSettings } from "../../utils/api";

export default {
  name: "AccountSetting",
  data() {
    return {
      strRealName: "",
      userinfo: {},
      userName: "",
      visible: false,
      cropperOptions: {
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 270, //默认生成截图框宽度
        autoCropHeight: 150, //默认生成截图框高度
        fixedBox: false, //是否固定截图框大小 不允许改变
        previewsCircle: false, //预览图是否是圆形
        title: "上传课程封面", //模态框上显示的标题
      },
      imgType: "testUp", //图片存储在oss上的上级目录名
      imgUrl: require("@/assets/imgs/course/upload.png"), //上传图片所得到的地址
      stunumber: 1,
      name: "",
      phone: "",
      email: "",
      phonecode: "",
      emailcode: "",
      btnTitle: "",
      showName: false,
      showPhone: false,
      showEmail: false,
      showheader: false,
      showModal: false,
      edit: false,
      inputname: false,
      inputnames: true,
      verShow: true,
      verShows: true,
      timer: 60,
      emailtime: 60,
    };
  },
  components: {
    upModal,
    ImageCropper,
    editModal,
  },
  methods: {
    sendrole(value) {
      this.userinfo.ddUserSex.iNumber = value;
    },
    cancel() {
      this.$router.go(-1);
    },
    update() {
        //手机号和邮箱的验证规则
      var reg = /^(\+86)?(13|15|17|18|14)\d{9}$/;
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(this.userinfo.strUserPhone) && this.userinfo.strUserPhone && this.$i18n.locale == 'zh') {
        return this.$message.error(this.$t('translateText.accountSet.IncorrectPhoneFormat'));
      } else
      if (this.strRealName == "" ||  this.strRealName.split(" ").join("").length ==0) {
        return this.$message.error(this.$t('translateText.accountSet.NameNotEmpty'))
      }else if (!regEmail.test(this.userinfo.strUserEmail) && this.userinfo.strUserEmail) {
        this.$message.error(this.$t('translateText.accountSet.IncorrectEmailFormat'));
      } else {
        let imgUrl = this.imgUrl
        let bool =  this.isBase64(this.imgUrl);
        if(!bool){
            imgUrl = ""
        }
        accountSettings({
          iUserId: this.userinfo.iUserId,
          strRealName: this.strRealName,
          strUserPhone: this.userinfo.strUserPhone,
          ddUserSex: {
            iNumber: this.userinfo.ddUserSex.iNumber,
          },
          strUserImgUrl: imgUrl,
          strUserEmail: this.userinfo.strUserEmail,
        }).then((response) => {
          if (response.data.iCode == 0) {
            this.userinfo.strRealName = this.strRealName;
            this.userinfo.strUserImgUrl = this.imgUrl;
            // var userinfo = JSON.stringify(this.userinfo)
            // localStorage.setItem("userinfo",userinfo);
            this.$store.commit("getUserInfo", this.userinfo);
            return (
              this.$message.success(this.$t('translateText.accountSet.ModifiedSuccessfully')), this.$router.push("/home")
            );
          } else {
            if(response.data.strMessage == '该手机号已存在！'){
              return this.$message.error(this.$t('translateText.accountSet.NumberExists'));
            }else{
              return this.$message.error(response.data.strMessage);
            }
          }
        });
      }
    },
    //判断是否是base64
    isBase64(str){
        if(str.substring(0,4) == "data"){
            return true
        }else {
            return false
        }
    },
    modifyinfo() {
      UpdateUser({
        user: {
          iUserId: this.UserId,
          strRealName: this.RealName,
          ddUserSex: {
            iNumber: this.Sex,
          },
          userClass: {
            iClassId: 0,
          },
          strUserPhone: this.Phone,
          strUserEmail: this.Email,
        },
        listRoleId: [this.RoleName],
      }).then(() => {});
    },
    validateBtn() {
      //倒计时
      this.verShow = false;
      var auth_timer = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          this.verShow = true;
          clearInterval(auth_timer);
        }
      }, 1000);
    },
    valiemailBtn() {
      //倒计时
      this.verShows = false;
      var auth_email = setInterval(() => {
        this.emailtime--;
        if (this.emailtime <= 0) {
          this.verShows = true;
          clearInterval(auth_email);
        }
      }, 1000);
    },
    cropOk(value) {
      this.imgUrl = value;
    },
    changeCover() {
      this.showModal = true;
      this.visible = true;
      this.$refs.son.option.fixedNumber = [1, 1];
      this.$refs.son.option.autoCropWidth = 150;
    },
    //上传操作结束
    cropClose() {
      console.log("上传操作结束");
    },
    //上传图片成功
    cropSuccess(data) {
      this.imgUrl = data;
    },
    upload() {
      //点击左侧图片上传事件
      this.showModal = true;
    },
    GiveUp() {
      (this.category = []), (this.Teachername = ""), (this.introArea = "");
      this.$store.commit("updatacondition", 11);
    },
    save() {
      this.$message.error(this.$t('translateText.accountSet.InterfaceNotOpen'));
    },
    editCancel() {
      //更换封面（editModal）取消按钮
      this.visible = false;
    },
    changeData() {
      let edit = JSON.parse(localStorage.getItem("editInfo"));
      this.imgUrl = edit.imgSrc;
      this.Teachername = edit.auth;
      this.introArea = edit.title;
    },
    cancelname() {
      this.showName = false;
    },
    //修改邮箱email
    handleemailOk() {
      this.sendinfo();
    },
    cancelemail() {
      this.showEmail = false;
    },
    //修改手机号
    handlephoneOk() {
      this.sendinfo();
    },
    cancelphone() {
      this.showPhone = false;
    },
  },
  watch: {
    name(val) {
      //输入中文或英文
      var reg = /^[\u0391-\uFFE5A-Za-z]+$/;
      if (reg.test(val)) {
        this.inputname = true;
        this.inputnames = false;
      } else {
        this.inputnames = true;
        this.inputname = false;
      }
    },
    phone(val) {
      //开头是1 第二位是3-9 的11位数字
      let reg = /^1[3-9][0-9]{9}$/;
      if (reg.test(val)) {
        this.phone - val;
      }
    },
    email(val) {
      //邮箱
      var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (reg.test(val)) {
        this.email = val;
      }
    },
  },
  created() {
    this.userinfo = this.$store.state.userinfo;
    this.strRealName = this.userinfo.strRealName;
    this.imgUrl = this.userinfo.strUserImgUrl;
  },
  mounted() {
    // this.sexnumber = this.userinfo.ddUserSex.iNumber
  },
};
</script>

<style lang="stylus" scoped>
maincolor = #818181;
.button{
  position :absolute
  left :30%;
  bottom: 20%
  // margin-left :-250px;
  // bottom :140px
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: maincolor;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: maincolor;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: maincolor;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: maincolor;
}

input:focus::-webkit-input-placeholder {
  color: maincolor;
}

.account-setting {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
  border-radius: 5px;
  margin-top: 0px;

  .setting-name {
    position: absolute;
    // font-size: 2.12962962962vh
    font-size: 2.22222222222vh;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 59px;
    top: 2.366%;
    margin-left: 36px;
  }

  .line-top {
    position: absolute;
    left: 50%;
    top: 10.5975%;
    transform: translateX(-50%);
    border: 1px solid #D5D5D5;
    background-color: #D5D5D5;
    width: 96%;
  }

  .container {
    position: absolute;
    width: 100%;
    height: 90%;
    top: 9.5975%;
    left: 0;
    // background-color:#cccccc;
    padding: 0 0 0 0;

    .head-portrait {
      position: absolute;
      top: 23.3%;
      left: 8.7%;
      width: 16%;
      height: 38%;

      @media screen and (max-height: 1100px) and (max-width: 900px) {
        width: 28.04%;
        height: 30%;
        left: 3%;
      }

      @media screen and (min-height: 1200px) and (min-width: 1000px) {
        width: 27.74%;
        height: 24%;
        left: 3%;
      }

      .complite-header {
        position: relative;
        width: 110px;
        height: 32px;
        margin-top: 6%;
        margin-left: 21%;
        text-align: center;
        border: 1px solid #4F4F4F;
        border-radius: 4px;
        cursor: pointer;
        // @media screen and (min-height: 600px) and (max-height: 750px)
        // margin-left:30%
      }

      .header-imagin {
        display: inline-block;
        // margin-top:2%
        // width: 100%
        // height: 74%
        // position: absolute
        // top: 2%
        // left: 50%
        // transform: translateX(-50%)
        // border: 0
        // border-radius: 10px
      }

      .header-img {
        display: inline-block;
        width: 16px;
        height: 16px;
        position: absolute;
        top: 50%;
        left: 18%;
        transform: translateY(-50%);
      }

      .header-name {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 34%;
        transform: translateY(-50%);
      }
    }

    .personal-inform {
      position: absolute;
      top: 16.6%;
      right: 27.5%;
      width: 30vw;
      height: 50.5%;

      // @media screen and (min-height: 600px) and (max-height: 750px)
      // width: 40vw
      // right:17%
      @media screen and (max-height: 1100px) and (max-width: 900px) {
        width: 58vw;
        right: 2%;
      }

      @media screen and (min-height: 1200px) and (min-width: 1000px) {
        width: 58vw;
        height: 40%;
        right: -2%;
      }

      .student {
        display: inline-block;
        position: absolute;
        left: 0.342%;
        // font-size: 2.03703703703vh
        font-size: 2.03703703703703vh;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }

      .student-number {
        top: 0.638%;
      }

      .input {
        display: inline-block;
        position: absolute;
        font-size: 1.85185185185vh;
        color: #818181;
        left: 21.88%;
        outline-color: #2EADB5;
      }

      .input-stunumber {
        top: 1.038%;
        // font-size: 1.48148148148vh
      }

      .name {
        top: 21.05%;
      }

      .updatainform {
        display: inline-block;
        position: absolute;
        left: 79%;
        color: red;
      }

      .updatename {
        top: 21.47%;
      }

      .updatephone {
        top: 62.055%;
      }

      .updateemail {
        top: 84.43%;
      }

      .input-stuname {
        height: 11.34%;
        width: 53.4%;
        top: 18.47%;
        text-align: left;
        // padding-top: 2%;
        border: 1px solid #B1B1B1;
        border-radius: 5px;
        outline-color: #2EADB5;
      }

      .student-sex {
        top: 42.283%;
      }

      .select-sex {
        top: 41.183%;

        .girl {
          display: inline-block;
        }

        .girl {
          display: inline-block;
          position: absolute;
          left: 100px;
        }
      }

      .student-phone {
        top: 62.155%;
      }

      .input-phone {
        top: 58.46%;
        height: 12.34%;
        width: 53.4%;
        text-align: left;
        // padding-top: 2%;
        border: 1px solid #B1B1B1;
        border-radius: 5px;
        outline-color: #2EADB5;
      }

      .student-email {
        top: 84.63%;
      }

      .input-email {
        top: 80.85%;
        height: 12.34%;
        width: 53.4%;
        text-align: left;
        // padding-top: 2%;
        border: 1px solid #B1B1B1;
        border-radius: 5px;
        outline-color: #2EADB5;
      }

      .inform-button {
        // margin-top: 76%;
        // @media screen and (max-width:700px) and (max-height: 750px)
        // margin-top:90%
      }

      .compile {
        margin-left: 20%;
      }

      .renturn-inform {
        margin-left: 80%;
      }
    }
  }
}

.peoplename {
  /deep/.ant-modal-content {
    display: inline-block;
    width: 400px;
    height: 200px;
    margin-left: 18%;
    margin-top: 24%;
  }

  /deep/.ant-modal-footer {
    border-top: none;
    margin-top: 90px;
  }

  /deep/.ant-btn-primary {
    background: #2EADB5;
    margin-right: 25%;
    margin-left: 18%;
  }
}

.prompt-updata-name {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;

  .prompt-name {
    font-size: 2.22222222222vh;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin-top: 4%;
  }

  .prompt-names {
    left: 10%;
    top: 41%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .prompt-input {
    left: 24%;
    top: 38.8%;
    width: 52%;
    height: 15%;
    outline: none;
    border: 1px solid #888888;
    border-radius: 4px;
    font-size: 1.85185185185vh;

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      height: 12%;
      font-size: 1.36666666vh;
    }
  }

  .duihao {
    text-align: center;
    top: 41.4%;
    right: 14%;
    width: 16px;
    height: 16px;
    background: url('../../assets/imgs/duihao.png');
    background-size: cover;
  }

  .chahao {
    text-align: center;
    top: 41.4%;
    right: 14%;
    width: 16px;
    height: 16px;
    line-height: 12px;
    background: red;
    color: white;
    border-radius: 50%;
    font-weight: 700;
  }
}

.peoplephone {
  /deep/.ant-modal-content {
    display: inline-block;
    width: 400px;
    height: 280px;
    margin-left: 18%;
    margin-top: 16%;
  }

  /deep/.ant-modal-footer {
    border-top: none;
    margin-top: 160px;
  }

  /deep/.ant-btn-primary {
    background: #2EADB5;
    margin-right: 25%;
    margin-left: 18%;
  }
}

.peopleemail {
  /deep/.ant-modal-content {
    display: inline-block;
    width: 400px;
    height: 280px;
    margin-left: 18%;
    margin-top: 16%;
  }

  /deep/.ant-modal-footer {
    border-top: none;
    margin-top: 160px;
  }

  /deep/.ant-btn-primary {
    background: #2EADB5;
    margin-right: 25%;
    margin-left: 18%;
  }
}

.prompt-updata-email {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;

  .prompt-email-name {
    font-size: 2.22222222222vh;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    margin-top: 4%;
    text-align: center;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.888888888vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.888888888vh;
    }
  }

  .prompt-email-names {
    left: 8%;
    top: 31%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .prompt-email-codes {
    left: 8%;
    top: 54.6%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .prompt-input-code {
    left: 30%;
    top: 51%;
    width: 59%;
    height: 14%;
    outline: none;
    border: 1px solid #888888;
    border-radius: 4px;
    font-size: 1.85185185185vh;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.366666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.366666666vh;
    }
  }

  .shuxian {
    width: 1px;
    height: 8%;
    position: absolute;
    top: 54.5%;
    left: 66%;
    background: #888888;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      left: 68%;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      left: 68%;
    }
  }

  .email-line {
    width: 1px;
    height: 8%;
    position: absolute;
    top: 54.5%;
    left: 61%;
    background: #888888;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      left: 65%;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      left: 62.8%;
    }
  }

  .get-codes {
    font-size: 1.85185185185vh;
    top: 54.4%;
    right: 13%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.366666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.366666666vh;
    }
  }

  .prompt-input-email {
    left: 30%;
    top: 28%;
    width: 59%;
    height: 14%;
    outline: none;
    border: 1px solid #888888;
    border-radius: 4px;
    font-size: 1.85185185185vh;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.366666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.366666666vh;
    }
  }

  .prompt-email-button {
    bottom: 9%;
    border-radius: 5px;
    outline: none;
    border: 0px;
    width: 21%;
    height: 13.1%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .prompt-email-cancel {
    left: 22%;
  }

  .prompt-email-save {
    right: 22%;
    background: #2EADB5;
  }
}

.prompt-updata-header {
  position: absolute;
  top: 20.7%;
  left: 50%;
  transform: translateX(-50%);
  width: 32.23%;
  height: 44.9%;
  border-radius: 14px;
  border: 1px solid #cccccc;
  background: #FFFFFF;
  box-shadow: 0px 2px 28px 4px rgba(86, 86, 86, 0.09);
  border-radius: 8px;

  @media screen and (max-height: 1100px) and (max-width: 900px) {
    width: 62%;
    height: 38%;
  }

  @media screen and (min-height: 1200px) and (min-width: 1000px) {
    width: 66%;
    height: 34%;
  }

  .header-one {
    left: 12%;
    top: 21%;
  }

  .header-two {
    width: 24%;
    height: 26%;
    top: 24%;
    right: 16.5%;
  }

  .header-look {
    top: 12%;
    right: 23%;
    font-size: 1.85185185185vh;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4F4F4F;
    line-height: 32px;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .header-tf {
    width: 10%;
    height: 14%;
    bottom: 28%;
  }

  .header-three {
    right: 32%;
    border-radius: 50%;
  }

  .header-four {
    right: 14%;
  }

  .header-button {
    width: 16%;
    height: 9%;
    border-radius: 5px;
    outline: none;
    bottom: 10%;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.466666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.466666666vh;
    }
  }

  .header-cancel {
    left: 30%;
    background: white;
    border: 1px solid #7C838D;
  }

  .header-save {
    right: 30%;
    background: #2EADB5;
    border: 0px;
    color: white;
  }

  .header-title {
    top: 11%;
    left: 12%;
    font-weight: bold;

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      font-size: 1.666666666vh;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      font-size: 1.666666666vh;
    }
  }

  .upload-headbtn {
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4F4F4F;
    line-height: 32px;
    bottom: 32%;
    left: 13%;
    font-size: 1.05185185185vh;

    @media screen and (max-height: 700px) {
      bottom: 26%;
    }

    @media screen and (max-height: 1100px) and (max-width: 900px) {
      bottom: 41%;
    }

    @media screen and (min-height: 1200px) and (min-width: 1000px) {
      bottom: 48%;
    }
  }

  .header-cha {
    top: 7%;
    right: 6%;
    width: 12px;
    height: 12px;
  }
}

.headers {
  display: inline-block;
  position: absolute;
}

.ant-radio-wrapper-checked {
  color: #2EADB5 !important;
}

.ant-radio-checked .ant-radio-inner {
  border-color: #2EADB5 !important;
}

/deep/ .ant-upload.ant-upload-select-picture-card {
  margin: 8% 0;
  width: 195px;
  height: 130px;
}

/deep/ .ant-select-selection--multiple .ant-select-selection__rendered {
  height: 33px;
}
</style>